import React from 'react';
import { Page } from 'react-pdf';
import { useAppSelector } from '../../hooks';
import { getSessionState } from '../../store/SessionSlice';
import QuestionPage from '../../pages/UserPages/Resources/components/QuestionPage';

interface PdfViewerBodyProps {
  selectedPageNumber: string;
  pageWidth?: number;
  scale: number;
}

const PdfViewerBody: React.FC<PdfViewerBodyProps> = ({
  selectedPageNumber,
  pageWidth,
  scale,
}) => {
  const sessionState = useAppSelector(getSessionState);

  const questions = sessionState.session?.questions;

  const RENDER_CONTENT = () => {
    const questionPage = questions.find(
      (question) => question.pageNo === Number(selectedPageNumber)
    );

    if (questionPage) {
      return <QuestionPage questionPage={questionPage} pageWidth={pageWidth} />;
    }
    return (
      <Page
        pageNumber={
          Number(selectedPageNumber) -
            questions.filter(
              (question) => Number(question.pageNo) < Number(selectedPageNumber)
            ).length || 1
        }
        scale={scale}
        width={pageWidth}
        className="pdf-rounded"
      />
    );
  };

  return <div style={{ maxWidth: pageWidth }}>{RENDER_CONTENT()}</div>;
};

export default PdfViewerBody;
